import { Fragment } from 'react'
import { Modal, Table } from '@jisr-hr/design-system'
import { Typography, Flex } from '@jisr-hr/ds'
import { usePaymentListSelector } from 'redux/payrollOnboarding/paymentReview/selectors'
import I18n from 'translations/i18n'
import styles from './styles.module.css'
import { ViewMoreModalProps } from '../../SummaryReview'

const headers = [
  { key: 'emp_id', label: I18n.t('emp_id'), width: '290px' },
  { key: 'employment_type', label: I18n.t('employment_type') },
  { key: 'payment_type', label: I18n.t('payment_type') },
  { key: 'Salary Type', label: I18n.t('salary_type') },
  { key: 'Bank Name', label: I18n.t('bank_name') },
  { key: 'IBAN', label: I18n.t('iban_onboarding') },
  { key: 'Salary Card No', label: I18n.t('salary_card_no') },
  { key: 'swift code', label: I18n.t('swift_code') },
  { key: 'Country', label: I18n.t('country') },
]

const ViewMoreModal = ({ isOpen, onClose }: ViewMoreModalProps): JSX.Element => {
  const { payment_details } = usePaymentListSelector()

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      variant="centerDialog"
      width={955}
      height={780}
      header={
        <Typography
          variant="title-1"
          text={I18n.t('employee_payment_details')}
        />
      }
      content={
        <div className={styles.modalContent}>
          <Table
            variant="rounded"
            headers={headers}
            containerStyles={{ maxHeight: 528 }}
          >
            {payment_details?.map((item) => (
              <Fragment key={item.id}>
                <Table.Row>
                  <Table.Cell>
                    <Flex
                      flexCol
                      style={{ width: 210 }}
                    >
                      <Typography
                        variant="subtitle-2"
                        text={item.name_i18n}
                      />
                      <Typography
                        variant="subtitle-2"
                        text={item.code}
                      />
                    </Flex>
                  </Table.Cell>
                  <Table.Cell>{item.employment_type || '-'}</Table.Cell>
                  <Table.Cell>{item.payment_type_i18n}</Table.Cell>

                  <Table.Cell>{item.salary_type_i18n || '-'}</Table.Cell>
                  <Table.Cell>{item.bank_name || item.bank_name_i18n || '-'}</Table.Cell>
                  <Table.Cell>{item.iban || '-'}</Table.Cell>
                  <Table.Cell>{item.account_number || '-'}</Table.Cell>
                  <Table.Cell>{item.swift_code || '-'}</Table.Cell>
                  <Table.Cell>{item.country || '-'}</Table.Cell>
                </Table.Row>
              </Fragment>
            ))}
          </Table>
        </div>
      }
    />
  )
}

export default ViewMoreModal
